import globalAxios from "../../../util/Api";
import {
  GET_PROJECTS_LIST,
  GET_PROJECT_DATA,
  DELETE_PROJECT,
  CREATE_PROJECT,
  EDIT_PROJECT,
  START_LOADING,
  ERROR,
  STOP_LOADING,
  YEAR_LIST,
  GET_AVAILABLE_CONSULTANTS,
  PROJECT_PLANS_FOR_YEAR,
  INVOICES_DATA,
  BUILD_INVOICE,
  ACTIVITIES_DATA,
  COMPARE_LIST,
  GET_FOROWN_LIST,
  GET_FOROTHER_LIST,
  LOGIN_ERROR,
  GET_USER_FOR_PM
} from "./types";
import { GetConsultantsFunction } from "../../ConsultantFunction/consultantAction";
import numeral from 'numeral';
import 'numeral/locales/de'
import { LogoutAction } from "../../../actions";
numeral.locale('de');

export const GetProjects = (key) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/projects`)
      .then(res => {
        const newres = res.data.projects.map(obj => {
          obj['name'] = obj['project_with_number']
          delete obj['project_with_number']
          return obj
        })
        if (res) {
          dispatch({ type: GET_PROJECTS_LIST, payload: newres })
          dispatch({ type: GET_FOROWN_LIST, payload: res.data.for_own })
          dispatch({ type: GET_FOROTHER_LIST, payload: res.data.for_other })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch({ type: LOGIN_ERROR, payload: err.response.data.errors })
            dispatch(LogoutAction())
          }
          else if (err)
            dispatch({ type: LOGIN_ERROR, payload: "Network Error" })
      })
  }
}

export const GetUserForManager = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/users_for_pm`)
      .then(res => {
        dispatch({ type: GET_USER_FOR_PM, payload: res.data.available_consultant })
      })
  }
}

export const GetProjectData = (id, invoice) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/projects/${id}`)
      .then(res => {
        if (res) {
          if (invoice) {
            dispatch({ type: GET_PROJECT_DATA, payload: res.data })
          } else {
            dispatch({ type: GET_PROJECT_DATA, payload: res.data })
            dispatch(FetchYear(id))
            dispatch(GetAvailableConsultants(id))
            dispatch(GetConsultantsFunction())
            dispatch({ type: PROJECT_PLANS_FOR_YEAR, payload: [] });
          }

        }
      })
  }
}

export const ProjectFunctionsAndFeeAction = (dataObj) => {

  let bodyFormData = new FormData();
  dataObj.consultantList.map((item, index) => {
    bodyFormData.append(`project[project_functions_attributes][${index}][consultant_function_id]`, item.functionId);
    bodyFormData.append(`project[project_functions_attributes][${index}][dailyrate]`, numeral(item.dailyRate).value());
    bodyFormData.append(`project[project_functions_attributes][${index}][days]`, numeral(item.days).value());
    bodyFormData.append(`project[project_functions_attributes][${index}][id]`, item.rowId);
  })
  bodyFormData.append('project[travelrate]', numeral(dataObj.travelrate).value());
  bodyFormData.append('project[assistancerate]', numeral(dataObj.assistancerate).value());
  bodyFormData.append('project[administrationrate]', numeral(dataObj.administrationrate).value());
  bodyFormData.append('project[startdate]', dataObj.startDate);
  bodyFormData.append('project[enddate]', dataObj.endDate);
  bodyFormData.append('project[addcostsinfo]', dataObj.costInfo);


  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`api/v1/projects/${dataObj.projectId}`, bodyFormData)
      .then(res => {
        dispatch({ type: GET_PROJECT_DATA, payload: res.data })
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}

export const CreateNewProject = (dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('project[active]', dataObj.active);
  bodyFormData.append('project[archived]', dataObj.archived);
  bodyFormData.append('project[comment]', dataObj.comment);
  bodyFormData.append('project[branch_id]', dataObj.branche);
  bodyFormData.append('project[customer_id]', dataObj.kunde);
  bodyFormData.append('project[dailyproof]', dataObj.dailyProof);
  bodyFormData.append('project[internal]', dataObj.externIntern);
  bodyFormData.append('project[invoiceaddress]', dataObj.invoiceaddress);
  bodyFormData.append('project[management]', dataObj.managment);
  bodyFormData.append('project[shortcut]', dataObj.shortcut);
  bodyFormData.append('project[projectmanagement]', dataObj.projectManagement);
  bodyFormData.append('project[project_manager_id]', dataObj.projectmanager.id !== undefined ? dataObj.projectmanager.id : dataObj.projectmanager);
  bodyFormData.append('project[probability]', dataObj.probability);
  bodyFormData.append('project[projectname]', dataObj.projectName);
  bodyFormData.append('project[projectno]', dataObj.projectNumber);
  bodyFormData.append('project[reference]', dataObj.reference);
  bodyFormData.append('project[secret]', dataObj.secret);
  bodyFormData.append('project[toleranceplaning]', numeral(dataObj.tolerancePlanning).value());
  bodyFormData.append('project[toleranceregistering]', numeral(dataObj.toleranceRegistering).value());
  bodyFormData.append('project[hoursperday]', numeral(dataObj.hoursperday).value());
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/projects`, bodyFormData)
      .then(res => {
        const newres = res.data.projects
        newres['name'] = newres['projectname']
        delete newres['projectname']
        if (newres) {
          dispatch({ type: CREATE_PROJECT, payload: newres })
          dispatch(GetProjects("new"))
          dispatch(GetProjectData(newres.id))
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}

export const EditProject = (dataObj) => {

  let bodyFormData = new FormData();
  bodyFormData.append('project[active]', dataObj.active);
  bodyFormData.append('project[archived]', dataObj.archived);
  bodyFormData.append('project[comment]', dataObj.comment);
  bodyFormData.append('project[branch_id]', dataObj.branche === null ? '' : dataObj.branche);
  bodyFormData.append('project[customer_id]', dataObj.kunde);
  bodyFormData.append('project[dailyproof]', dataObj.dailyProof);
  bodyFormData.append('project[internal]', dataObj.externIntern);
  bodyFormData.append('project[invoiceaddress]', dataObj.invoiceaddress);
  bodyFormData.append('project[management]', dataObj.managment);
  bodyFormData.append('project[shortcut]', dataObj.shortcut);
  bodyFormData.append('project[projectmanagement]', dataObj.projectManagement);
  bodyFormData.append('project[project_manager_id]', dataObj.projectmanager.id !== undefined ? dataObj.projectmanager.id : dataObj.projectmanager);
  bodyFormData.append('project[probability]', dataObj.probability);
  bodyFormData.append('project[projectname]', dataObj.projectName);
  bodyFormData.append('project[projectno]', dataObj.projectNumber);
  bodyFormData.append('project[reference]', dataObj.reference);
  bodyFormData.append('project[secret]', dataObj.secret);
  bodyFormData.append('project[toleranceplaning]', numeral(dataObj.tolerancePlanning).value());
  bodyFormData.append('project[toleranceregistering]', numeral(dataObj.toleranceRegistering).value());
  bodyFormData.append('project[hoursperday]', numeral(dataObj.hoursperday).value());
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/projects/${dataObj.projectId}`, bodyFormData)
      .then(res => {
        const newres = res.data.project
        newres['name'] = newres['projectname']
        delete newres['projectname']
        if (newres) {
          dispatch({ type: EDIT_PROJECT, payload: newres })
          dispatch(GetProjects())
          dispatch(GetProjectData(newres.id))

        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}

export const DeleteProject = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/projects/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_PROJECT })
          dispatch(GetProjects())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}

export const CompareCapacityWithPlan = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/project_plans/capacity_planning_comparison?project_id=${id}`)
      .then(res => {
        dispatch({ type: COMPARE_LIST, payload: res.data.comparison_data })
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}

export const FetchYear = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/projects/${id}/fetch_year`)
      .then(res => {
        if (res) {
          dispatch({ type: YEAR_LIST, payload: res.data.years })
        }
      }).catch(err => {

        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const AddYear = (id, year) => {

  let bodyFormData = new FormData();
  bodyFormData.append('year', year);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`api/v1/projects/${id}/add_year`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch(GetProjectData(id))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const UpdateCapacityPlannings = (dataObj) => {

  let bodyFormData = new FormData();
  let index = null
  dataObj.projectData.map((item) => {
    for (let i = 0; i < item.newRow.length; i++) {
      if (item.newRow[i].days !== null) {
        index = index === null ? 0 : index + 1
        bodyFormData.append(`project[project_years_attributes][${index}][consultant_function_id]`, item.functionId);
        bodyFormData.append(`project[project_years_attributes][${index}][year]`, item.newRow[i].year);
        bodyFormData.append(`project[project_years_attributes][${index}][days]`, item.newRow[i].days);
        bodyFormData.append(`project[project_years_attributes][${index}][id]`, item.newRow[i].rowId);
      }
    }
  })

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`api/v1/projects/${dataObj.projectId}`, bodyFormData)
      .then(res => {
        dispatch({ type: GET_PROJECT_DATA, payload: res.data })
      }).catch(err => {

      })
  }
}

export const GetAvailableConsultants = (id) => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/available_consultants?id=${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_AVAILABLE_CONSULTANTS, payload: res.data.available_consultant })
        }
      })
  }
}
export const AddConsultantFunctionForProject = (dataObj, stateData) => {
  let bodyFormData = new FormData();
  bodyFormData.append(`project[project_consultants_attributes][1][consultant_function_id]`, stateData.consultant_function_id ? stateData.consultant_function_id : "");
  bodyFormData.append(`project[project_consultants_attributes][1][user_id]`, stateData.id);
  bodyFormData.append(`project[project_consultants_attributes][1][secret]`, 0);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/projects/${dataObj.id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: GET_PROJECT_DATA, payload: res.data })
          dispatch(GetAvailableConsultants(dataObj.id))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const UpdateConsultantForProject = (propsProjectData) => {
  let bodyFormData = new FormData();

  propsProjectData.project_consultants.map((item, index) => {
    bodyFormData.append(`project[project_consultants_attributes][${index}][consultant_function_id]`, item.consultant_function_id ? item.consultant_function_id : '');
    bodyFormData.append(`project[project_consultants_attributes][${index}][user_id]`, item.user_id);
    bodyFormData.append(`project[project_consultants_attributes][${index}][id]`, item.id);
    bodyFormData.append(`project[project_consultants_attributes][${index}][secret]`, item.secret);
    bodyFormData.append(`project[project_consultants_attributes][${index}][_destroy]`, 0);
  })

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/projects/${propsProjectData.id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: GET_PROJECT_DATA, payload: res.data })
          dispatch(GetAvailableConsultants(propsProjectData.id))
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const DeleteConsultantForProject = (selectedList, propsProjectData) => {
  let bodyFormData = new FormData();
  bodyFormData.append(`project[project_consultants_attributes][1][consultant_function_id]`, selectedList.consultant_function_id);
  bodyFormData.append(`project[project_consultants_attributes][1][user_id]`, selectedList.user_id);
  bodyFormData.append(`project[project_consultants_attributes][1][secret]`, selectedList.secret);
  bodyFormData.append(`project[project_consultants_attributes][1][id]`, selectedList.id);
  bodyFormData.append(`project[project_consultants_attributes][1][_destroy]`, 1);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/projects/${propsProjectData.id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: GET_PROJECT_DATA, payload: res.data })
          dispatch(GetAvailableConsultants(propsProjectData.id))
        }
      })
  }
}



export const GetProjectPlansForYear = (projectID, year) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/project_plans?project_id=${projectID}&year=${year}`)
      .then(res => {
        dispatch({ type: PROJECT_PLANS_FOR_YEAR, payload: res.data });
      }).catch(err => {
      })
  }
}
export const CreateProjectPlansForYear = (projectID, data, monthData, year) => {
  let bodyFormData = new FormData();
  let index = null

  data.map((item) => {
    monthData.forEach((month) => {
      if (month !== "summary") {
        if (item.project_plans[month]) {
          index = index === null ? 0 : index + 1
          bodyFormData.append(`project[project_plans_attributes][${index}][daysassigned]`, item.project_plans[month][0].daysassigned);
          bodyFormData.append(`project[project_plans_attributes][${index}][dayssold]`, item.project_plans[month][0].dayssold);
          bodyFormData.append(`project[project_plans_attributes][${index}][month]`, "01 " + item.project_plans[month][0].month + " " + year);
          bodyFormData.append(`project[project_plans_attributes][${index}][project_id]`, projectID);
          bodyFormData.append(`project[project_plans_attributes][${index}][user_id]`, item.user_id);
        }
      }
    })
  })
  bodyFormData.append(`year`, year);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`api/v1/projects/${projectID}/create_update_project_plans`, bodyFormData)
      .then(res => {
        dispatch({ type: PROJECT_PLANS_FOR_YEAR, payload: res.data });
      }).catch(err => {
      })
  }
}

export const GetInvoices = (projectID) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/invoices?project_id=${projectID}`)
      .then(res => {
        dispatch({ type: INVOICES_DATA, payload: res.data });
      }).catch(err => {
      })
  }
}
export const BuildInvoice = (projectID) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/invoices/new?project_id=${projectID}`)
      .then(res => {
        dispatch({
          type: BUILD_INVOICE, payload: res.data.invoices
        });
      }).catch(err => {

      })
  }
}

export const CreateNewInvoice = (data) => {
  let bodyFormData = new FormData();
  bodyFormData.append(`invoice[administrationcosts]`, data.administrationcost);
  bodyFormData.append(`invoice[assistencecosts]`, data.assistancecosts);
  bodyFormData.append(`invoice[comment]`, data.comment);
  bodyFormData.append(`invoice[date]`, data.date);
  bodyFormData.append(`invoice[invoiceno]`, data.invoiceNumber);
  bodyFormData.append(`invoice[project_id]`, data.propsProjectData.id);
  bodyFormData.append(`invoice[totalfees]`, data.totalfeesSum);
  bodyFormData.append(`invoice[totalgross]`, data.totalgross);
  bodyFormData.append(`invoice[totalnet]`, data.totalnet);
  bodyFormData.append(`invoice[travelcosts]`, data.travelcosts);
  bodyFormData.append(`invoice[vat]`, data.vatField);
  bodyFormData.append(`invoice[vatrate]`, data.vatRateField);

  data.invoicePosition.forEach((data, index) => {
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][days]`, data.days);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][dailyrate]`, data.dailyrate);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][consultant_function_id]`, data.consultant_function_id);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][totalfees]`, data.totalfees);
  })

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`api/v1/invoices?project_id=${data.propsProjectData.id}`, bodyFormData)
      .then(res => {
        dispatch(GetInvoices(data.propsProjectData.id));
        dispatch(GetProjectData(data.propsProjectData.id, true))
      }).catch(err => {
        if (err.response) {
          dispatch({ type: ERROR, payload: err.response.data.errors })
        }
      })
  }
}

export const EditInvoice = (data) => {
  let bodyFormData = new FormData();
  bodyFormData.append(`invoice[administrationcosts]`, data.administrationcost);
  bodyFormData.append(`invoice[assistencecosts]`, data.assistancecosts);
  bodyFormData.append(`invoice[comment]`, data.comment);
  bodyFormData.append(`invoice[date]`, data.date);
  bodyFormData.append(`invoice[invoiceno]`, data.invoiceNumber);
  bodyFormData.append(`invoice[project_id]`, data.propsProjectData.id);
  bodyFormData.append(`invoice[totalfees]`, data.totalfeesSum);
  bodyFormData.append(`invoice[totalgross]`, data.totalgross);
  bodyFormData.append(`invoice[totalnet]`, data.totalnet);
  bodyFormData.append(`invoice[travelcosts]`, data.travelcosts);
  bodyFormData.append(`invoice[vat]`, data.vatField);
  bodyFormData.append(`invoice[vatrate]`, data.vatRateField);

  data.invoicePosition.forEach((data, index) => {
    if (data.id !== null)
      bodyFormData.append(`invoice[invoice_positions_attributes][${index}][id]`, data.id);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][days]`, data.days);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][dailyrate]`, data.dailyrate);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][consultant_function_id]`, data.consultant_function_id);
    bodyFormData.append(`invoice[invoice_positions_attributes][${index}][totalfees]`, data.totalfees);
  })

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`api/v1/invoices/${data.invoiceId}?project_id=${data.propsProjectData.id}`, bodyFormData)
      .then(res => {
        dispatch(GetInvoices(data.propsProjectData.id));
        dispatch(GetProjectData(data.propsProjectData.id, true))
      }).catch(err => {
        if (err.response) {
          dispatch({ type: ERROR, payload: err.response.data.errors })
        }
      })
  }
}

export const FilterInvoices = (data) => {

  let monthField
  if (data.monthField !== "") {
    monthField = "01." + data.monthField + "." + data.yearField
  }

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/invoices?project_id=${data.propsProjectData.id}&${data.monthField !== "" ? `q[date_gteq]=${monthField}` : `q[date_gteq]=${data.dateFrom}&q[date_lteq]=${data.dateTo}`}`)
      .then(res => {
        dispatch({ type: INVOICES_DATA, payload: res.data });

        // dispatch({
        //   type: FILTERED_INVOICES, payload: res.data.invoices
        // });
      }).catch(err => {
        if (err.response) {
          dispatch({ type: ERROR, payload: err.response.data.errors })
        }
      })
  }
}

export const DeleteInvoice = (projectID, invoiceId) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`api/v1/invoices/${invoiceId}`)
      .then(res => {
        dispatch(GetInvoices(projectID));
      }).catch(err => {
      })
  }
}

export const GetActivities = (projectID) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`api/v1/project_activities?project_id=${projectID}`)
      .then(res => {
        dispatch({ type: ACTIVITIES_DATA, payload: res.data.project_activities });
      }).catch(err => {
      })
  }
}
export const CreateNewActivity = (data) => {
  let bodyFormData = new FormData();
  bodyFormData.append('project_activity[activity]', data.activityField)
  bodyFormData.append('project_activity[keyword]', data.keywordField)
  bodyFormData.append('project_activity[project_id]', data.propsProjectData.id)
  bodyFormData.append('project_activity[token]', data.abbrivationField)
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`api/v1/project_activities`, bodyFormData)
      .then(res => {
        dispatch(GetActivities(data.propsProjectData.id));
      }).catch(err => {
        if (err.response) {
          dispatch({ type: ERROR, payload: err.response.data.project_activity })
        }
      })
  }
}
export const EditActivity = (data) => {
  let bodyFormData = new FormData();
  bodyFormData.append('project_activity[activity]', data.activityField)
  bodyFormData.append('project_activity[keyword]', data.keywordField)
  bodyFormData.append('project_activity[project_id]', data.propsProjectData.id)
  bodyFormData.append('project_activity[token]', data.abbrivationField)
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`api/v1/project_activities/${data.activityID}`, bodyFormData)
      .then(res => {
        dispatch(GetActivities(data.propsProjectData.id));
      }).catch(err => {
        if (err.response) {
          dispatch({ type: ERROR, payload: err.response.data.project_activity })
        }
      })
  }
}

export const DeleteActivity = (projectID, activityID) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`api/v1/project_activities/${activityID}`)
      .then(res => {
        dispatch(GetActivities(projectID));
      }).catch(err => {
      })
  }
}

export const StopLoading = () => {
  return (dispatch) => {
    dispatch({ type: STOP_LOADING })
  }
}
